import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const CSV_TYPE = 'text/csv;charset=utf-8"';
const CSV_EXTENSION = '.csv';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
const EXCEL_EXTENSION = '.xlsx';
const ZIP_TYPE = 'application/zip';

@Injectable()
export class CSVService {
  constructor() { }
  saveAsCSVFile(data: any, fileName: string): void {
    const blob: Blob = new Blob([data], { type: CSV_TYPE });
    FileSaver.saveAs(blob, fileName + CSV_EXTENSION);
  }

  saveAsXLSXFile(data: any, fileName: string): void {
    const blob: Blob = new Blob([data], { type: EXCEL_TYPE });
    FileSaver.saveAs(blob, fileName + EXCEL_EXTENSION);
  }

  saveAsZipFile(data: any, fileName: string): void {
    const blob: Blob = new Blob([data], { type: ZIP_TYPE });
    FileSaver.saveAs(blob, fileName);
  }

 public exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet = XLSX.utils.json_to_sheet(json);
    const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const buffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsXLSXFile(buffer, excelFileName);
  }
}
